import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { OrganizationIcon, LocationIcon, EmailIcon, PhoneIcon, WebsiteIcon, PartnershipsIcon, ProgramsIcon, ImpactIcon } from './Icons';
import './Contact.css';

const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>{t.contactTitle}</h2>
          <p>{t.contactIntro}</p>
        </div>
        
        <div className="contact-grid">
          <div className="contact-card">
            <h3>{t.organization}</h3>
            <div className="contact-item">
              <div className="contact-icon">
                <OrganizationIcon />
              </div>
              <div className="contact-details">
                <p className="contact-label">{t.organizationName}</p>
                <p className="contact-value">{t.organizationType}</p>
              </div>
            </div>
          </div>

          <div className="contact-card">
            <h3>{t.contactInfo}</h3>
            <div className="contact-item">
              <div className="contact-icon">
                <LocationIcon />
              </div>
              <div className="contact-details">
                <p className="contact-label">{t.address}</p>
                <p className="contact-value">{t.sudan}</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <EmailIcon />
              </div>
              <div className="contact-details">
                <p className="contact-label">{t.email}</p>
                <p className="contact-value">
                  <a href="mailto:info@mandula.org">info@mandula.org</a>
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <PhoneIcon />
              </div>
              <div className="contact-details">
                <p className="contact-label">{t.phone}</p>
                <p className="contact-value">
                  <a href="tel:+249912797684">+249 912 797 684</a><br />
                  <a href="tel:+249129552787">+249 129 552 787</a>
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <WebsiteIcon />
              </div>
              <div className="contact-details">
                <p className="contact-label">{t.website}</p>
                <p className="contact-value">
                  <a href="http://www.mrro-sudan.org" target="_blank" rel="noopener noreferrer">
                    www.mrro-sudan.org
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="commitment-section">
          <h3>{t.ourCommitment}</h3>
          <p>{t.commitmentP1}</p>
          <p>{t.commitmentP2}</p>
          
          <div className="commitment-grid">
            <div className="commitment-item">
              <div className="commitment-icon">
                <PartnershipsIcon />
              </div>
              <p>{t.strongPartnerships}</p>
            </div>
            <div className="commitment-item">
              <div className="commitment-icon">
                <ProgramsIcon />
              </div>
              <p>{t.effectivePrograms}</p>
            </div>
            <div className="commitment-item">
              <div className="commitment-icon">
                <ImpactIcon />
              </div>
              <p>{t.sustainableImpact}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
